module.exports = __webpack_public_path__ + "static/img/citi.aa6e38a7.svg";